module.exports = __webpack_public_path__ + "img/astral-txt_23.341ee553.svg";